import { any, object } from 'prop-types';
import React from 'react';
import _get from 'lodash/get';
import styled from 'styled-components';

import Responsive from 'ravenjs/lib/Responsive';
import Col from 'ravenjs/lib/Col';
import Row from 'ravenjs/lib/Row';

import Sidebar from 'components/Sidebar';

const MobileDetailsViewStyled = styled.div`
    max-width: 100%;
`;

const DesktopDetailsViewStyled = styled.div`
    ${({ hasSidebar }) => {
        const maxWidth = hasSidebar ? 'calc(100% - 300px);' : '100%';
        return {
            maxWidth,
        };
    }};
`;

const ChildrenWrapper = styled.div`
    padding: ${({ padding }) => padding};
`;

function DetailsView(props) {
    const { children, sidebar, col } = props;
    const size = col ? _get(col, 'largeSize') : 9;
    const padding = col ? _get(col, 'padding') : '0 25px';
    const mobileView = (
        <MobileDetailsViewStyled hasSidebar={sidebar}>
            <Row>
                <Col size={12}>
                    <ChildrenWrapper padding={padding}>{children}</ChildrenWrapper>
                    {sidebar ? <Sidebar {...sidebar} /> : null}
                </Col>
            </Row>
        </MobileDetailsViewStyled>
    );
    const desktopView = (
        <DesktopDetailsViewStyled hasSidebar={sidebar}>
            <Row margin="0 1rem 0 -0.8125rem">
                <Col size={{ lg: size }}>
                    <ChildrenWrapper>{children}</ChildrenWrapper>
                    {sidebar ? <Sidebar {...sidebar} /> : null}
                </Col>
            </Row>
        </DesktopDetailsViewStyled>
    );

    return (
        <>
            <Responsive size="md" value="less">
                {mobileView}
            </Responsive>
            <Responsive size="md" value="greater">
                {desktopView}
            </Responsive>
        </>
    );
}

DetailsView.propTypes = {
    /**
     * Configuration object for rendering the details view sidebar
     */
    sidebar: object,

    /**
     * A list of childrens that are passed in, if any
     */
    children: any,

    col: object,
};

DetailsView.defaultProps = {
    /**
     * By default, the view will render an empty
     */
    sidebar: null,

    /**
     * Default, no children passed in
     */
    children: null,

    col: null,
};

export default DetailsView;
